import React, { useEffect ,useState } from 'react';
import Loader from '../../../Components/Loader';
import CreateNewNeed from '../create-need';
import OpenRequest from './open-request';
import RecentDonation from './recent-donation';

type FundAHotelDashboardProps = {
  userData: any;
  triggerPopup: () => void;
};

const FundAHotelDashboard: React.FC<FundAHotelDashboardProps> = ({ userData, triggerPopup }) => {
  //  State for expanded details and active tab
  const [activeTab, setActiveTab] = useState("openRequest"); // Default tab
  const [isOpenRequestsLoading, setIsOpenRequestsLoading] = useState(false);
  const [isRecentDonationLoading, setIsRecentDonationLoading] = useState(false);
  const [updateFeedOpenRequest, setUpdateFeedOpenRequest] = useState(false);

  const startIsOpenRequestsLoading = () => {
    setIsOpenRequestsLoading(true);
  }

  const endIsOpenRequestsLoading = () => {
    setIsOpenRequestsLoading(false);
    setUpdateFeedOpenRequest(false);
  }

  const startIsRecentDonationLoading = () => {
    setIsRecentDonationLoading(true);
  }

  const endIsRecentDonationLoading = () => {
    setIsRecentDonationLoading(false);
  }

  const updateFeed = () => {
    if (activeTab === 'openRequest') {
      setUpdateFeedOpenRequest(true)
    }
  }

  useEffect(() => {
    if (userData && userData.hasSeenNewUiPopup !== true) {
      triggerPopup();
    }
  }, [userData]);

  return (
    <>
      {(activeTab === 'openRequest' && isOpenRequestsLoading) && <Loader />}
      {(activeTab === 'recentDonation' && isRecentDonationLoading) && <Loader />}
      <div className="container py-4 md:py-10 2xl:py-[70px]">
        <div className="mb-3 md:mb-4 2xl:mb-8 flex justify-center">
          <CreateNewNeed updateFeed={updateFeed} />
        </div>
        {/* Tabs */}
        <div className="flex mb-6">
          <button
            className={`px-4 2xl:px-6 py-3 md:text-sm 2xl:text-base font-medium border-b-2 ${activeTab === 'openRequest'
              ? 'border-primary text-primary'
              : 'text-gray-500'
              }`}
            onClick={() => setActiveTab('openRequest')}
          >
            Open Alerts
          </button>
          <button
            className={`px-4 2xl:px-6 py-3 md:text-sm 2xl:text-base font-medium border-b-2 ${activeTab === 'recentDonation'
              ? 'border-primary text-primary'
              : 'text-gray-500'
              }`}
            onClick={() => setActiveTab('recentDonation')}
          >
            Recent Donations
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === 'openRequest' && (
          <OpenRequest updateFeedOpenRequest={updateFeedOpenRequest} startIsOpenRequestsLoading={startIsOpenRequestsLoading} endIsOpenRequestsLoading={endIsOpenRequestsLoading} />
        )}

        {activeTab === 'recentDonation' && (
          <RecentDonation startIsRecentDonationLoading={startIsRecentDonationLoading} endIsRecentDonationLoading={endIsRecentDonationLoading} />
        )}
      </div>
    </>
  );
};

export default FundAHotelDashboard;
